var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3999 10C1.3999 5.75768 1.3999 3.63558 2.71769 2.31779C4.03548 1 6.15664 1 10.3999 1C14.6422 1 16.7643 1 18.0821 2.31779C19.3999 3.63558 19.3999 5.75674 19.3999 10C19.3999 14.2423 19.3999 16.3644 18.0821 17.6822C16.7643 19 14.6432 19 10.3999 19C6.15759 19 4.03548 19 2.71769 17.6822C1.3999 16.3644 1.3999 14.2433 1.3999 10Z",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.618 4.78955H15.6085M14.663 10.0001C14.663 11.1307 14.2139 12.2151 13.4144 13.0146C12.6149 13.8141 11.5305 14.2632 10.3999 14.2632C9.26922 14.2632 8.18487 13.8141 7.38537 13.0146C6.58587 12.2151 6.13672 11.1307 6.13672 10.0001C6.13672 8.86942 6.58587 7.78507 7.38537 6.98557C8.18487 6.18607 9.26922 5.73692 10.3999 5.73692C11.5305 5.73692 12.6149 6.18607 13.4144 6.98557C14.2139 7.78507 14.663 8.86942 14.663 10.0001Z",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram01);
export default __webpack_public_path__ + "static/media/instagram01.e1c6285e34fab7da1373560e434c268b.svg";
export { ForwardRef as ReactComponent };